<template>
  <a-modal 
    width="70%"
    :title="data.name"
    v-model="visable"
    centered
    @ok="handleOk"
    @cancel="cancel"
    destroyOnClose
  >
    <a-table class="table" :pagination="pagination" :columns="columns" :dataSource="actionData" @change="pageChange"></a-table>
  </a-modal>
</template>
<script>
export default {
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      visable: true,
      columns: [],
      actionData: [],
      pagination: {
        pageSize: 10,
        current: 1,
        total: this.data.data.length,
        size: 'small',
      },
    }
  },
  methods: {
    handleOk () {
      this.visable = false
      this.$emit('quit')
    },
    cancel () {
      this.$emit('quit')
    },
    pageChange(page) {
      this.pagination.current = page.current
    },
    formatData (data) {
      this.columns = data.titles.map((item) => {
        return {
          title: item,
          dataIndex: item
        }
      })
      // console.log(this.columns)
      this.actionData = data.data.map((item) => {
        let temObj = {}
        for (let i = 0; i < item.length; i++) {
          temObj[this.data.titles[i]] = item[i]
        }
        // console.log(temObj)
        return temObj
      })
    }
  },
  created () {
    // console.log(this.data)
    this.formatData(this.data)
  }
}
</script>
